import React from "react";
import AlarmSectionView from "src/pages/section/AlarmSection/view";


export interface AlarmSectionMarqueeProps {
}
function AlarmSection(props:AlarmSectionMarqueeProps) {
    return  <AlarmSectionView/>;
}

export default AlarmSection;
